<ng-container *ngFor="let option of allCustomizationOptions">
    <!-- custom-message: text area -->
    <div *ngIf="option.type === 'custom-message' && option.message"
         class="mt-4 space-y-1">
        <label class="text-[14px] md:text-[16px] text-gray-900 mb-1" [style.font-weight]="500">
            {{ option.message.label || option.name }}
            <span *ngIf="option.message.required" class="text-red-500 ml-0.5">*</span>
        </label>
        <div *ngIf="option.message.description" class="text-xs text-gray-400">
            <span [innerHtml]="option.message.description | safeHtml"></span>
        </div>
        <textarea
            class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500 resize-none"
            rows="3"
            [placeholder]="option.message.label || option.name"
            [value]="messageValues[option.id] || ''"
            (input)="onMessageInput(option.id, $any($event.target).value)"></textarea>
    </div>

    <!-- custom-options: paid option selector -->
    <div *ngIf="option.type === 'custom-options' && option.paidOption"
         class="mt-4 space-y-2">
        <label class="option-group-label block text-[14px] md:text-[16px] text-gray-900 mb-1 mr-1" [style.font-weight]="500">
            {{ option.paidOption.label || option.name }}:<span *ngIf="option.paidOption.required" class="text-red-500 ml-0.5">*</span>
            <span *ngIf="selectedPaidOptionValues[option.id]" class="text-base font-bold text-gray-700 ml-1">
                {{ getSelectedPaidOptionLabel(option, selectedPaidOptionValues[option.id]) }}
            </span>
        </label>
        <div *ngIf="option.paidOption.showImage" class="text-xs text-gray-500">
            <span [innerHtml]="option.paidOption.description | safeHtml"></span>
        </div>
        <div class="flex flex-wrap gap-2">
            <!-- None option for non-required selections -->
            <div *ngIf="!option.paidOption.required"
                 (click)="onSelectPaidOption(option.id, '')"
                 class="cursor-pointer rounded-md border px-3 py-1.5 text-sm transition-colors duration-200 text-gray-500"
                 [ngClass]="{
                     'ring-2 ring-primary-600 border-primary-600 font-semibold': isNoneSelected(option.id),
                     'border-gray-300 hover:border-gray-400': !isNoneSelected(option.id)
                 }">
                None
            </div>
            <!-- Actual options -->
            <div *ngFor="let item of option.paidOption.options"
                 (click)="onSelectPaidOption(option.id, item.key)"
                 [title]="item.label"
                 class="cursor-pointer rounded-md border px-3 py-1.5 text-sm transition-colors duration-200 flex items-center gap-2"
                 [ngClass]="{
                     'ring-2 ring-primary-600 border-primary-600 font-semibold': selectedPaidOptionValues[option.id] === item.key,
                     'border-gray-300 hover:border-gray-400': selectedPaidOptionValues[option.id] !== item.key
                 }">
                <img *ngIf="option.paidOption.showImage && item.asset"
                     [src]="item.asset | assetPreview:'thumb':'webp'"
                     [alt]="item.label"
                     class="w-8 h-8 rounded object-cover">
                <span>{{ item.label }}</span>
                <span *ngIf="item.price" class="text-xs text-gray-500">
                    +{{ (item.price | separatedFormatPrice)?.currency }}{{ (item.price | separatedFormatPrice)?.price }}
                </span>
            </div>
        </div>
    </div>

</ng-container>
